// extracted by mini-css-extract-plugin
module.exports = {"textTruncate":"CardStyles_textTruncate__6DB3x","truncateWidthFix":"CardStyles_truncateWidthFix__Fmlhy"};